import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber9 = () => {
  return (
    <g>
      <path d="m8 .1819a7.8181 7.8181 0 1 0 7.818 7.8181 7.818 7.818 0 0 0 -7.818-7.8181zm-.3129 11.7692a2.4015 2.4015 0 0 1 -2.3818-1.4492l1.0127-.667a1.4173 1.4173 0 0 0 1.38.9775c1.2432 0 1.9336-1.22 1.9336-2.8418v-.1953h-.0353a1.99 1.99 0 0 1 -1.9092 1.2656 2.3067 2.3067 0 0 1 -2.4052-2.4509 2.504 2.504 0 0 1 2.6581-2.6 2.6587 2.6587 0 0 1 2.335 1.22 4.5579 4.5579 0 0 1 .6787 2.5654c0 2.4618-1.2537 4.1757-3.2666 4.1757z" />
      <path d="m7.9977 5.1171a1.3381 1.3381 0 0 0 -1.4043 1.415 1.3383 1.3383 0 0 0 1.4043 1.416 1.33 1.33 0 0 0 1.3691-1.416 1.33 1.33 0 0 0 -1.3691-1.415z" />
    </g>
  );
};

export default withIcon(IconNumber9);
